/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Question Statistics Service
 * This service is used to get question statistics
 * @file QuestionStatisticsService.js
 * @author Gladson Samuel S
 */

import Framework, { BaseService } from '@greenville/framework';
import { AET_STORE_EVENTS } from '../common/Constants';

export default class QuestionStatisticsService extends BaseService {
  constructor() {
    super(AET_STORE_EVENTS.QUESTION_STATISTICS_REQUESTED, 'questionStatisticsStatus');
  }

  /**
   * API call for Question Statistics
   * @param {*} eventName
   * @param {*} eventData
   * @returns {Promise}
   */
  handleEvent(eventName, eventData = {}) {
    const { courseId, assignmentId, questionId } = eventData;

    return this.getClient('marin').get(`/aet/courses/${courseId}/assignments/${assignmentId}/questions/${questionId}/statistics`);
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse(response, eventData = {}) {
    const { questionId } = eventData;
    const data = response?.data || {};

    Framework.getStoreRegistry().getStore('mcqAssignments').setStatisticsData(questionId, data);
    Framework.getEventManager().publish(AET_STORE_EVENTS.QUESTION_STATISTICS_COMPLETED, data);
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(error) {
    Framework.getEventManager().publish(AET_STORE_EVENTS.QUESTION_STATISTICS_FAILED, error);
  }
}
